import { Node } from '@tiptap/core';

var Accessability = Node.create({
    name: "accessibility",
    addCommands: function () {
        var _this = this;
        return {
            focusOnToolbar: function () { return function () {
                var _a, _b;
                (_b = (_a = _this.options.toolbarElement) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
                return true;
            }; },
        };
    },
    addKeyboardShortcuts: function () {
        var _this = this;
        /**
         * https://github.com/ueberdosis/tiptap/issues/1046
         * [x] - While the editor or anything inside is being focused, the first
         *       button in the toolbar should be selectable with Alt-F10. (After
         *       checking TinyMCE, CKEditor and WordPress' Gutenberg Editor this
         *       seems to be industry standard).
         *       Important: The current selection in the editor should be untouched!
         * [ ] - While using the toolbar clicking Esc should bring you back to the
         *       last selection in the content area.
         */
        return { "Alt-F10": function () { return _this.editor.commands.focusOnToolbar(); } };
    },
});

export { Accessability };
//# sourceMappingURL=accessibility.js.map
